import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { buscarDireccionesSucAuth } from "../services/direccionesService";
import { FILTROS_INICIALES, OPCIONES_FILTROS } from "../constants/pedido";

// Búsqueda de direcciones con filtros múltiples y debounce de 400 ms.
export const useBusquedaDirecciones = () => {
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState(FILTROS_INICIALES);
  const [inputValueDirecciones, setInputValueDirecciones] = useState("");
  const [todasDirecciones, setTodasDirecciones] = useState([]);
  const [loadingDirecciones, setLoadingDirecciones] = useState(false);

  const buscarDireccionesFiltradas = async (searchTerm, filtros) => {
    if (!searchTerm || searchTerm.trim().length < 2 || filtros.length === 0) {
      setTodasDirecciones([]);
      return;
    }

    setLoadingDirecciones(true);
    try {
      const sucursales = localStorage.getItem("suc_auth")?.split(",") || [];
      const data = await buscarDireccionesSucAuth(sucursales, searchTerm, filtros);
      setTodasDirecciones(data);
    } catch (error) {
      console.error("Error buscando direcciones:", error);
      setTodasDirecciones([]);
    } finally {
      setLoadingDirecciones(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((searchTerm, filtros) => {
      buscarDireccionesFiltradas(searchTerm, filtros);
    }, 400),
    [],
  );

  useEffect(() => {
    if (inputValueDirecciones.length >= 2 && filtrosSeleccionados.length > 0) {
      debouncedSearch(inputValueDirecciones, filtrosSeleccionados);
    } else {
      setTodasDirecciones([]);
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [inputValueDirecciones, filtrosSeleccionados, debouncedSearch]);

  const handleFiltrosChange = (nuevosFiltros) => {
    setFiltrosSeleccionados(nuevosFiltros);
  };

  const handleInputChange = (newInputValue) => {
    setInputValueDirecciones(newInputValue);
    if (newInputValue.length >= 2 && filtrosSeleccionados.length > 0) {
      debouncedSearch(newInputValue, filtrosSeleccionados);
    } else {
      setTodasDirecciones([]);
    }
  };

  const getPlaceholderText = (filtros) => {
    if (filtros.length === 0) {
      return "Seleccione filtros para buscar...";
    }

    if (filtros.length === OPCIONES_FILTROS.length) {
      return "Buscar en todos los campos...";
    }

    const filtrosLabels = filtros.map((filtro) => {
      const opcion = OPCIONES_FILTROS.find((f) => f.value === filtro);
      return opcion?.label
        .toLowerCase()
        .replace("por ", "")
        .replace(/[👤🏠🏙️📞📋🔢]/g, "")
        .trim();
    });

    return `Buscar por: ${filtrosLabels.join(", ")}...`;
  };

  return {
    filtrosSeleccionados,
    handleFiltrosChange,
    inputValueDirecciones,
    handleInputChange,
    todasDirecciones,
    loadingDirecciones,
    placeholder: getPlaceholderText(filtrosSeleccionados),
  };
};
